// App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import AdminLeads from "./pages/AdminLeads";
import ContactedHistory from "./pages/ContactedHistory"; // ✅ Make sure this file exists

import "./styles/App.css";

function App() {
  return (
    <Router>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
